import { render, staticRenderFns } from "./PrintQButtonGroup.vue?vue&type=template&id=0140bf20&"
import script from "./PrintQButtonGroup.vue?vue&type=script&lang=js&"
export * from "./PrintQButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports